import { Box, Button as MuiButton } from '@mui/material'
import { css, type Theme } from '@emotion/react'
import styled from '@emotion/styled'

export interface ButtonStyledProps {
  colorType?: 'solidRed' | 'solidBlue' | 'solidGreen' | 'outlineBlue'
}

const buttonModifier = {
  solidRed: (theme: Theme) => css`
    background: url('/src/assets/svgs/bg-red-button.svg') 50% / cover;
    color: ${theme.colors.lightest};

    &.Mui-disabled {
      color: ${theme.colors.border.light};
      pointer-events: auto;
      cursor: not-allowed !important;
    }
  `,
  solidBlue: (theme: Theme) => css`
    background: ${theme.colors.primary};
    color: ${theme.colors.lightest};

    &.Mui-disabled {
      background: ${theme.colors.gray.disabled};
      border: ${theme.colors.border.disabled};
      pointer-events: auto;
      cursor: not-allowed !important;

      .button-text {
        color: ${theme.colors.gray.dark};
        opacity: 0.6;
      }
    }
  `,
  solidGreen: (theme: Theme) => css`
    background: ${theme.colors.green.light};
    color: ${theme.colors.lightest};

    &:hover {
      background: ${theme.colors.green.color};
    }

    &.Mui-disabled {
      background: ${theme.colors.gray.disabled};
      border: ${theme.colors.border.disabled};
      pointer-events: auto;
      cursor: not-allowed !important;

      .button-text {
        color: ${theme.colors.gray.dark};
        opacity: 0.6;
      }
    }
  `,
  outlineBlue: (theme: Theme) => css`
    border: 1px solid ${theme.colors.primary};
    color: ${theme.colors.primary};

    &.Mui-disabled {
      background: ${theme.colors.gray.disabled};
      border-color: ${theme.colors.border.disabled};
      pointer-events: auto;
      cursor: not-allowed !important;

      .button-text {
        color: ${theme.colors.gray.dark};
        opacity: 0.6;
      }
    }
  `
}

export const Button = styled(MuiButton)<ButtonStyledProps>`
  ${({ theme, colorType }) => css`
    position: relative;
    height: 48px;
    border-radius: 8px;
    box-shadow: none !important;
    padding: 0px 16px;

    @media (max-width: ${theme.screenSizes.laptop}) {
      max-width: 100%;
    }

    &.Mui-disabled {
      opacity: 1;
      pointer-events: auto;
      cursor: not-allowed !important;
    }

    ${colorType && buttonModifier[colorType](theme)}
  `}
`

export const Text = styled(Box)`
  text-transform: none !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 22px;
  }
`

export const LoadingOverlay = styled(Box)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`
